var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItstrategyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H35.9883C42.6157 0 47.9883 5.37258 47.9883 12V35.9883C47.9883 42.6157 42.6157 47.9883 35.9883 47.9883H12C5.37258 47.9883 0 42.6157 0 35.9883V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9919 32.9883V30.9896C27.9919 29.9294 27.5707 28.9127 26.8211 28.163C26.0714 27.4133 25.0547 26.9922 23.9945 26.9922H17.9984C16.9382 26.9922 15.9214 27.4133 15.1718 28.163C14.4221 28.9127 14.001 29.9294 14.001 30.9896V32.9883",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9964 22.9948C23.2041 22.9948 24.9938 21.2051 24.9938 18.9974C24.9938 16.7897 23.2041 15 20.9964 15C18.7887 15 16.999 16.7897 16.999 18.9974C16.999 21.2051 18.7887 22.9948 20.9964 22.9948Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9873 32.9883V30.9896C33.9866 30.1039 33.6919 29.2435 33.1492 28.5435C32.6066 27.8435 31.8468 27.3435 30.9893 27.1221",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9912 15.1299C28.8511 15.35 29.6132 15.8501 30.1574 16.5513C30.7017 17.2524 30.9971 18.1148 30.9971 19.0024C30.9971 19.89 30.7017 20.7523 30.1574 21.4535C29.6132 22.1546 28.8511 22.6547 27.9912 22.8748",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItstrategyIcon);
export default __webpack_public_path__ + "static/media/itstrategy-icon.c475d7b8f0c6c081b77479e36b807c08.svg";
export { ForwardRef as ReactComponent };